import { jsx as _jsx } from "react/jsx-runtime";
export function Subheading({ className = "", children, ...rest }) {
    return (_jsx("p", { className: ["text-sm text-zinc-500", className].join(" "), ...rest, children: children }));
}
